/**
 * Recipe loading strategies for progressive loading
 */
export const RECIPE_LOADING_STRATEGY = {
  /** Load only minimal recipes (fast, excludes boolean expressions) */
  MINIMAL: "minimal",
  /** Load only full recipes (slower, includes boolean expressions) */
  FULL: "full"
} as const;

export type RecipeLoadingStrategy =
  (typeof RECIPE_LOADING_STRATEGY)[keyof typeof RECIPE_LOADING_STRATEGY];
